<template>
  <div class="flex items-center w-full space-x-3">
    <vetster-partner-photo
      :partner="partner"
      photo-size="size-16 lg:size-40"
    />
    <div class="flex justify-between items-center z-10 flex-1">
      <div class="w-full">
        <p class="font-title text-neutral-700 font-semibold text-xl leading-5 lg:text-3xl">
          {{ fullName }}
        </p>
        <div
          :class="{
            'lg:items-center': !hasRatings,
            'lg:items-end': hasRatings,
          }"
          class="w-full lg:flex lg:mt-1 *:leading-5 *:text-nowrap text-neutral-500 *:text-xs lg:*:text-sm lg:space-x-1"
        >
          <dl>
            <dt class="sr-only">
              {{ $t('vetster.designation') }}
            </dt>
            <dd class="text-wrap">
              {{ fullDesignation }}
            </dd>
          </dl>
          <span class="hidden lg:block text-neutral-500">・</span>
          <div>
            <button
              v-if="hasRatings && showReviewsButton"
              type="button"
              class="flex justify-start items-baseline mt-1 w-full"
              @click="$emit('toggle-reviews', $event)"
            >
              <vetster-reviews-count
                :partner="partner"
                left-separator-classes="hidden lg:block"
                show-left-separator
                :is-button="showReviewsButton"
              />
            </button>
            <div
              v-else-if="hasRatings"
              class="flex justify-start items-baseline mt-1 w-full"
            >
              <vetster-reviews-count
                :partner="partner"
                left-separator-classes="hidden lg:block"
                show-left-separator
              />
            </div>
            <dl
              v-else
              class="flex items-centre text-xs leading-4 mt-1 w-full tracking-tight lg:text-sm lg:mt-0"
            >
              <dt class="sr-only">
                {{ $t('search.rating-and-reviews') }}
              </dt>
              <dd class="flex items-center justify-start">
                <fa
                  :icon="['fal', 'star']"
                  class="text-bubblegum-500"
                />
                <p class="leading-4 ml-2 text-neutral-500 lg:leading-tight">
                  {{ $t('search.no-reviews-yet') }}
                </p>
              </dd>
            </dl>
          </div>
        </div>
        <vetster-partner-badges
          v-if="showBadges"
          :is-in-state="isInState"
          :is-vcpr-enabled="isVcprEnabled"
          :is-vcpr-search="isVcprSearch"
          :partner="partner"
          class="lg:mt-4"
        />
      </div>
    </div>
  </div>
</template>

<script>
import VetsterPartnerBadges from '@/brand-components/VetsterPartnerBadges';
import VetsterPartnerPhoto from '@/brand-components/VetsterPartnerPhoto';
import VetsterReviewsCount from '@/brand-components/VetsterReviewsCount';
import usePartnerHelpers from '@/composables/use-partner-helpers';

export default {
  name: 'VetsterPartnerProfile',

  components: {
    VetsterPartnerBadges,
    VetsterPartnerPhoto,
    VetsterReviewsCount,
  },

  props: {
    isInState: {
      type: Boolean,
      default: false,
    },
    isVcprEnabled: {
      type: Boolean,
      default: false,
    },
    isVcprSearch: {
      type: Boolean,
      default: false,
    },
    partner: {
      type: Object,
      required: true,
    },
    showBadges: {
      type: Boolean,
      default: false,
    },
    showReviewsButton: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const {
      fullDesignation,
      fullName,
    } = usePartnerHelpers(props.partner);

    return {
      fullDesignation,
      fullName,
    };
  },

  computed: {
    hasRatings() {
      return this.partner.rating_count > 0;
    },
  },
};
</script>
